<template>
  <div
    ref="scrubber"
    :class="{dark: isDark, [size]: size}"
    :style="scrubberStyles"
    class="scrubber"
  >
    <Waveform :store="store" />
  </div>
</template>

<script>
import Waveform from './Waveform'

export default {
  components: {
    Waveform
  },
  props: {
    store: {
      type: Object,
      default: function () {}
    }
  },
  data () {
    return {
      left: 0,
      width: 0
    }
  },
  computed: {
    isDark () { return this.store.state.isDark },
    size () { return this.store.state.size },
    scrubberStyles () {
      let opacity = 1

      if (this.size === 'size-mini' && (this.store.state.showShare === true || this.store.state.showSubscribe === true)) {
        opacity = 0
      }

      return {
        opacity: opacity
      }
    },
    showShare () { return this.store.state.showShare },
    showSubscribe () { return this.store.state.showSubscribe }
  }
}
</script>

<style lang="scss" scoped>
@import 'node_modules/simplecast-styles/src/assets/styles/_core/colors.scss';
@import '../assets/styles/breakpoints.scss';

.scrubber {
  cursor: pointer;
  height: 40px;
  position: relative;
  transition: opacity .5s;
  width: 100%;

  @media (min-width: $bp_xs) {
    height: 36px;
  }
  @media (min-width: $bp_sm) {
    height: 48px;
  }

  &.size-mini {
    background: $black-trans-200;
    border-radius: 2px;
    height: 36px;

    &.dark {
      background: $white-trans-200;
    }
  }
}
</style>
